import { Injectable } from '@angular/core';
import { map, startWith, distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  constructor() { }

  public readonly windowScroll$ = fromEvent(window, 'scroll').pipe(map(x => window.scrollY), startWith(0), distinctUntilChanged(), shareReplay(1));

  offsetTop(el) {
    console.log(el);
    var rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
   /* console.log(window.pageYOffset, rect.top);
    console.log("daje", rect.top); */
    return {top: rect.top + scrollTop, height: el.offsetHeight}
}
}
